import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search as SearchIcon, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  const doSearch = async (e) => {
    e?.preventDefault();
    if (q.trim().length < 2) return;
    setParams({ q }); setLoading(true);
    try { const r = await api.get("/search", { params: { q } }); setRes(r.data); } finally { setLoading(false); }
  };
  React.useEffect(() => { if (params.get("q")) doSearch(); /* eslint-disable-next-line */ }, []);

  return (
    <>
      <Seo title="Cerca" description="Cerca guide, FAQ e rivenditori SENIORCAR." noindex />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Cerca" }]} /></div>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 pt-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900" style={{ fontFamily: "Outfit" }}>Cerca nel sito</h1>
        <form onSubmit={doSearch} className="mt-6 flex gap-3">
          <div className="relative flex-1"><SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Guide, FAQ, rivenditori..." className="h-14 text-lg pl-11" data-testid="search-input" /></div>
          <Button type="submit" className="h-14 px-7 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="search-submit">Cerca</Button>
        </form>

        {loading && <p className="mt-8 text-slate-500">Ricerca in corso...</p>}
        {res && !loading && (
          <div className="mt-8 space-y-8" data-testid="search-results">
            {res.guides?.length > 0 && (<div><h2 className="text-xl font-bold text-slate-900 mb-3">Guide</h2>
              {res.guides.map((g) => <Link key={g.slug} to={`/guide/${g.slug}`} className="block rounded-xl bg-white border border-slate-200 p-4 mb-2 hover:shadow-md"><span className="text-xs text-amber-700 font-bold uppercase">{g.category}</span><p className="font-semibold text-slate-900">{g.title}</p></Link>)}</div>)}
            {res.faqs?.length > 0 && (<div><h2 className="text-xl font-bold text-slate-900 mb-3">FAQ</h2>
              {res.faqs.map((f, i) => <Link key={i} to="/faq" className="block rounded-xl bg-white border border-slate-200 p-4 mb-2 hover:shadow-md"><p className="font-semibold text-slate-900">{f.question}</p></Link>)}</div>)}
            {res.dealers?.length > 0 && (<div><h2 className="text-xl font-bold text-slate-900 mb-3">Rivenditori</h2>
              {res.dealers.map((d) => <Link key={d.slug} to={`/rivenditori/${d.city.toLowerCase()}/${d.slug}`} className="block rounded-xl bg-white border border-slate-200 p-4 mb-2 hover:shadow-md flex items-center justify-between"><span className="font-semibold text-slate-900">{d.dealer_name} — {d.city}</span><ArrowRight size={16} className="text-emerald-700" /></Link>)}</div>)}
            {res.guides?.length === 0 && res.faqs?.length === 0 && res.dealers?.length === 0 && <p className="text-slate-500">Nessun risultato per "{q}".</p>}
          </div>
        )}
      </section>
      <div className="h-16" />
    </>
  );
}
